import { createFileRoute } from '@tanstack/react-router';
import { ShowcasesList } from '@/features/showcases/showcases-list';

export const Route = createFileRoute('/_authenticated/showcases/')({
    head: () => ({ meta: [{ title: 'Showcases | promote.fun' }] }),
    component: ShowcasesList,
});
